// extracted by mini-css-extract-plugin
export var highlightOriginal = "_5x-0";
export var highlightSuggested = "_5x-1";